import {useCallback, useContext, useEffect} from 'react'

import {useWallet} from 'use-wallet'
import {Contract} from 'web3-eth-contract'
import {ethers} from 'ethers'

import {FarmContext} from "../contexts/farm_provider/farm_provider";

const useApprove = () => {
    const {account} = useWallet();
    const {lpContract, sC} = useContext(FarmContext);
    const addr = sC.options.address;
    const handleApprove = useCallback(async () => {
        try {
            const tx = await lpContract.methods
                .approve(addr, ethers.constants.MaxUint256)
                .send({from: account});

            return tx
        } catch (e) {
            console.log('----------------->' + e);
            return false
        }
    }, [account, lpContract, addr]);


    return {onApprove: handleApprove}
};

export default useApprove
